<template>
  <el-drawer
  title="Filtres"
  :visible.sync="visible"
  :direction="direction"
  :before-close="handleClose"
  :size="width"
  @open="open">
  <div class="drawer__content scrollable only-y" :style="divHeight" >
    <el-form v-model="model" label-position="top">
      <div class="border p-10 mb-20" >
        <el-form-item  v-if="showDateBy" label="Dates">
          <el-radio-group v-model="model.dateByPaidAt" size="small">
            <el-radio :label="false" border>Date de facturation</el-radio>
            <el-radio :label="true" border>Date de paiement</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('reports.filters.'+predefinePeriodLabelCode)">
          <el-select v-model="model.period" popper-class="predefined_popper" value-key="code" @select="handlePeriodSelect">
            <el-option
              v-for="item in predefinedPeriod"
              :key="item.code"
              :label="$t('reports.filters.predefined.'+item.code)"
              :value="item">
              <span >{{ $t('reports.filters.predefined.'+item.code) }}</span><br>
              <span class="fs-14 secondary-text">{{ item.description }}</span>
            </el-option>
          </el-select>
          <el-date-picker
            class="mt-20"
            v-if="model.period!=null && model.period.code=='CUSTOM' && model.period.range"
            v-model="model.dateRange"
            type="daterange"
            range-separator="à"
            start-placeholder="Date de début"
            end-placeholder="Date de fin">
          </el-date-picker>
          <el-date-picker
            class="mt-20"
            v-if="model.period!=null && model.period.code=='CUSTOM' && !model.period.range"
            v-model="model.date"
            type="date">
          </el-date-picker>
        </el-form-item>
      </div>
      <el-form-item  v-if="groups.length>0" label="Regrouper par">
        <el-radio-group v-model="model.group" size="small">
          <el-radio v-for="(item,index) in groups" :key="index" :label="item" border>{{$t('reports.filters.groups.'+item)}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item  v-if="showReportLevel" label="Type de rapport">
        <el-radio-group v-model="model.detailed" size="small">
          <el-radio :label="false" border>Sommaire</el-radio>
          <el-radio :label="true" border>Détaillé</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="Client" v-if="customerFilter">
        <SelectCustomer @selected="handleCustomerSelect" :customer="model.customer" multiple></SelectCustomer>
      </el-form-item>
      <el-form-item label="Fournisseur" v-if="providerFilter">
        <SelectCustomer @selected="handleProviderSelect" :customer="model.provider"></SelectCustomer>
      </el-form-item>
      <el-form-item label="Produit(s)" v-if="productFilter">
        <SelectProduct @selected="handleProductSelect" :product="model.product" :summary="true"></SelectProduct>
      </el-form-item>
      <el-form-item  v-if="currencies.length>0" label="Devises">
        <el-select v-model="model.currencies" value-key="id" multiple>
          <el-option
            v-for="item in currencies"
            :key="item.id"
            :label="item.code"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item  v-if="customer_classes.length > 0" label="Classe client">
        <el-select v-model="model.customer_classes" value-key="id" multiple>
          <el-option
            v-for="item in customer_classes"
            :key="item.id"
            :label="item.code"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item  v-if="paymentMethods.length>0" label="Mode de paiement">
        <el-select v-model="model.paymentMethods" value-key="code" multiple>
          <el-option
            v-for="item in paymentMethods"
            :key="item.code"
            :label="$t('invoices.'+item.code)"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item  v-if="inventories.length>0" label="Inventaire">
        <el-select v-model="model.inventories" value-key="id" multiple>
          <el-option
            v-for="item in inventories"
            :key="item.id"
            :label="item.name"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item  v-if="reps.length>0" label="Représentant">
        <el-select v-model="model.reps" value-key="id" multiple>
          <el-option
            v-for="item in reps"
            :key="item.id"
            :label="item.firstName + ' ' + item.lastName"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item  v-if="statusesCollection.length>0" label="Statut(s)">
        <el-select v-model="model.statuses" value-key="code" multiple :disabled="model.dateByPaidAt===true">
          <el-option
            v-for="item in statusesCollection"
            :key="item.code"
            :label="$t(statusType+'.'+item.code)"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
   </el-form>
   <div class="dialog-footer card-shadow--large">
     <el-button @click="handleClose">Annuler</el-button>
     <el-button type="primary" @click="save">Appliquer</el-button>
   </div>
  </div>
</el-drawer>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import moment from 'moment';

import SelectCustomer from '@/components/customer/select-customer'
import SelectProduct from '@/components/product/select-product'

export default {
  name: 'report-filter',
	props: {
    visible : {type : Boolean},
    predefinePeriodLabelCode : {
      type : String,
      default : 'PredefinedPeriod'
    },
    predefinedPeriod : {
      type : Array,
      default : () => []
    },
    period : Object,
    dateBy: {
      type : String,
      default : 'Date'
    },
    groups : {
      type : Array,
      default : () => []
    },
    group : String,
    endDate : String,
    startDate : String,
    paidAtEndDate : String,
    paidAtStartDate : String,
    date : String,
    customerFilter : {
      type  : Boolean,
      default : false
    },
    providerFilter : {
      type  : Boolean,
      default : false
    },
    productFilter : {
      type  : Boolean,
      default : false
    },
    customer : {
      type : Object,
      default : null
    },
    provider : {
      type : Object,
      default : null
    },
    paymentMethods : {
      type :Array,
      default : () => []
    },
    methods : {
      type : Array,
      default : () => []
    },
    statusesCollection : {
      type : Array,
      default : () => []
    },
    statusType : {
      type : String,
      default : ''
    },
    statuses : {
      type : Array,
      default : () => []
    },
    direction : {
      type : String,
      default : "rtl" //rtl / ltr / ttb / tbb
    },
    inventories : {
      type : Array,
      default : () => [],
    },
    selectedInventories : {
      type: Array,
      default: () => [],
    },
    inventory : {
      type : Object,
      default : null
    },
    reps : {
      type : Array,
      default : () => []
    },
    selectedReps : {
      type: Array,
      default: () => [],
    },
    customer_classes : {
      type : Array,
      default : () => []
    },
    selectedCustomerClasses : {
      type : Array,
      default : () => [],
    },
    showReportLevel : {
      type : Boolean,
      default :false
    },
    paidAt : {
      type : Boolean,
      default : false
    },
    showDateBy : {
      type : Boolean,
      default : false,
    },
    detailed : {
      type : Boolean,
      default : true,
    },
    selectedProduct : {
      type : Object,
      default: null,
    },
    currencies: {
      type: Array,
      default: () => [],
    },
    selectedCurrencies: {
      type: Array,
      default: () => [],
    }
	},
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      model : {
        period : null,
        group : null,
        dateRange : [],
        dateByPaidAt : false,
        paymentMethods : [],
        customer : null,
        provider: null,
        customer_classes : [],
        date : null,
        reps : [],
        detailed : false,
        product: [],
        currencies: [],
        inventories : [],
      },
    };
  },components: {
    SelectCustomer,
    SelectProduct
  },
	methods: {
    handleProductSelect (product) {
      if(product!=null && product!=''){
        this.model.product = product;
      }else{
        this.model.product = null;
      }
    },
    handleCustomerSelect(customer){
      if(customer!=null && customer!=''){
        this.model.customer = customer;
      }else{
        this.model.customer = null;
      }

    },
    handleProviderSelect(provider){
      if(provider!=null && provider!=''){
        this.model.provider = provider;
      }else{
        this.model.provider = null;
      }

    },
    handlePeriodSelect(period){
      if(period!=null && period.code!='CUSTOM'){
        this.model.dateRange = null;
      }
    },
    save(){
      this.$emit('applyFilter',this.model);
      this.handleClose();
    },
    open(){
      this.model.dateByPaidAt = this.paidAt;
      this.model.period = this.period;
      this.model.group = this.group;
      this.model.detailed = this.detailed;
      if(this.date!=null)this.model.date=this.date;

      if(this.startDate!=null && this.endDate!=null){
        this.model.dateRange=[];
        this.model.dateRange.push(this.startDate);
        this.model.dateRange.push(this.endDate);
      }

      if(this.paidAtStartDate!=null && this.paidAtEndDate!=null){
        this.model.paidAtDateRange=[];
        this.model.paidAtDateRange.push(this.paidAtStartDate);
        this.model.paidAtDateRange.push(this.paidAtEndDate);
      }

      this.model.customer = this.customer;
      this.model.reps = this.selectedReps;
      this.model.currencies = this.selectedCurrencies;
      this.model.product = this.selectedProduct;
      this.model.inventory = this.inventory;

      if (!_.isEmpty(this.selectedInventories)) {
        _.forEach(this.selectedInventories, (inv) => {
          this.model.inventories.push({ id: inv });
        })
      }

      if (!_.isEmpty(this.selectedCustomerClasses)) {
        _.forEach(this.selectedCustomerClasses, (cc) => {
          this.model.customer_classes.push({ id: cc });
        })
      }

      if(this.methods!=null && this.methods.length>0){
        this.model.paymentMethods = [];
        _.forEach(this.methods, m=>{
          let method = _.find(this.paymentMethods, method=>{return method.id==m})
          this.model.paymentMethods.push(method);
        })
      }
    },
    handleClose(){
      this.$emit('close');
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
	},
	computed: {
    divHeight(){
      return "height :"+(this.window.height-130) + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "40%";
      }else{
        return "100%"
      }
    },
	},
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>

// .el-row {
//     margin-bottom: 20px;
//     &:last-child {
//       margin-bottom: 0;
//     }
//   }

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

.predefined_popper li{
  padding-top:10px;
  height:55px;
  line-height:18px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
